import { Component, OnInit } from '@angular/core';
import { Store } from "@ngrx/store";
import { AppState } from "../../../../src/app/services/state/app.state";
import * as UserActions from "../../../../src/app/services/state/actions/user.action";
@Component({
  selector: 'app-not-found-page',
  templateUrl: './not-found-page.component.html',
  styleUrls: ['./not-found-page.component.css']
})
export class NotFoundPageComponent implements OnInit {

  constructor( private store: Store<AppState>) { }

  ngOnInit(): void {
  }
  clear(){
    this.store.dispatch(new UserActions.Logout());
  }

}
